import type { LntDropdownMenuItem } from '@app/components/base/Dropdown/types'
import type { FileType } from '@app/types'

export const getExportFilesDropdownMenu = (
  label: string,
  types: FileType[],
  onClick: (fileType: FileType) => Promise<void>
): LntDropdownMenuItem[] => {
  return types.map(type => ({
    label: `${label} (.${type})`,
    key: `export-${type}`,
    onClick: async () => await onClick(type)
  }))
}
